import { Game } from "./game";

const viewport = document.getElementById("viewport");
if (!viewport) {
  throw new Error("missing #viewport");
}

const game = new Game(viewport);

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
